<script setup>
import { computed } from 'vue'
import { newsStyle } from '@/lib/news'

/**
 * The icon of a news (see doc/news.md): the event type's own when the news tells of an event, the
 * icon of its category otherwise. `boxed` sets it on a tinted square, for a card or a dialog header.
 */
const props = defineProps({
  news: { type: Object, required: true },
  size: { type: [Number, String], default: 20 },
  boxed: { type: Boolean, default: false },
})

const style = computed(() => newsStyle(props.news))
</script>

<template>
  <div v-if="boxed" class="news-icon-box" :class="`text-${style.color}`">
    <v-icon :size="size" color="inherit">{{ style.icon }}</v-icon>
  </div>
  <v-icon v-else :size="size" :color="style.color">{{ style.icon }}</v-icon>
</template>

<style scoped>
.news-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  /* currentColor is the tint of the category/event, set by the text-<colour> class. */
  background: color-mix(in srgb, currentColor 16%, transparent);
}
</style>
